import { Component, OnInit, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import { Observable } from 'rxjs/Observable';

import { ArgomentoService } from './../../../services/argomento.service';
import { Argomento } from '../../../models/Argomento';

@Component({
  selector: 'app-argomento-search',
  templateUrl: './argomento-search.component.html',
  styleUrls: ['./argomento-search.component.css'],
  providers: [
    ArgomentoService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ArgomentoSearchComponent),
      multi: true
    }
  ]

})
export class ArgomentoSearchComponent implements OnInit {
  stateCtrl: FormControl;
  public loading = false;

  argomenti: Observable<any>;
  selected: Argomento;
  descrizione: string;

  constructor(private argomentoService: ArgomentoService) {
    this.stateCtrl = new FormControl();
  }

  onOptionSelected(e) {
    console.log(e.option.value)
    this.selected = e.option.value;
    // this.propagateChange(this.selected);
        this.propagateChange( e.option.value);
  }

  onChange(e) {
    console.log('change', e)
  }

  ngOnInit() {
    this.stateCtrl.valueChanges
      .debounceTime(200)
      .subscribe(val => {
        let boo = (typeof (val) === 'string' || val instanceof String);
        // console.log('INIZIO autore change: ', val);
        // console.log('val string: ', (val instanceof String));
        // console.log('boo: ', boo);
        if (boo) {
          this.loading = true;
          this.argomenti = this.argomentoService.search(val)
            .map(result => {
              console.log(result)
              this.loading = false;
              this.selected = undefined;
              this.propagateChange(undefined);
              if (result.success) {
                return result.items;
              }
            })
        }
      })
  }

  displayFn(item) {
    return item ? item.descrizione : item;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Argomento) {
    console.log('======= ************ writeValue', obj)
    this.descrizione = obj ? obj.descrizione : undefined;
    this.selected = obj;
    // this.propagateChange(this.selected);
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/argomento/argomento-search/argomento-search.component.ts